import React, {useMemo} from 'react';
import {Link, useLocation} from 'react-router-dom';

import Button from '@pb/kit-component-button';
import {Group} from '@pb/kit-component-group';
import Icon, {Icons} from '@pb/kit-component-icon';

import {SSO_BASE_PATH, SSO_STEPS} from '../../constants';
import {useUserPrimaryAccountName} from '../../hooks/use-user-primary-account-name';
import {SUPPORT_EMAIL, buildSupportMailto} from '../../utils/build-support-mailto';

import {footer} from './step-footer.module.styl';

type StepFooterProps = {
    onContinue: () => unknown,
    onBack?: () => void,
    continueDisabled?: boolean,
    continueLabel?: string,
    busy?: boolean,
};

export const StepFooter: React.FC<StepFooterProps> = ({onContinue, onBack, continueDisabled, continueLabel, busy}) => {
    const {accountName, accountId} = useUserPrimaryAccountName();
    const location = useLocation();

    const supportMailto = useMemo(() => {
        const segment = location.pathname.replace(SSO_BASE_PATH, '').replace(/^\//, '').split('/')[0];
        // The index route ('') renders the first step (Get Started) without a path segment.
        const step = segment === '' ? SSO_STEPS[0] : SSO_STEPS.find(s => s.path === segment);
        return buildSupportMailto({
            accountName,
            accountId,
            stepNumber: step?.number ?? null,
            stepLabel: step?.label ?? null,
        });
    }, [accountName, accountId, location.pathname]);

    return (
        <div className={footer}>
            <div style={{minWidth: 60}}>
                {onBack != null && (
                    <Button variant="Type.SECONDARY" onClick={onBack}>
                        Back
                    </Button>
                )}
            </div>
            <Group justify="center" alignItems="center" gap="xxs">
                <Icon type={Icons.ENVELOPE} size="Size_12"/>
                Need help?&nbsp; Contact us at
                <Link to={supportMailto}>
                    {SUPPORT_EMAIL}
                </Link>
            </Group>
            <Button variant="Type.PRIMARY" onClick={onContinue} disabled={continueDisabled} busy={busy}>
                {continueLabel ?? 'Continue'}
            </Button>
        </div>
    );
};
